import { Injectable } from '@angular/core';
import { NbMenuItem } from '@nebular/theme';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  public menuItems: NbMenuItem[] = [
    {
      title: 'Buchungen',
      icon: 'list',
      link: '/buchungen'
    },
    {
      title: 'Konten',
      icon: 'book',
      link: '/kontos' 
    },
    {
      title: 'Bilanz',
      icon: 'pie-chart',
      link: '/bilanz'
    },
    {
      title: 'Vermögensaufbau',
      icon: 'trending-up',
      link: '/vermoegen'
    },
    {
      title: 'Einstellungen',
      icon: 'settings',
    },
    {
      title: 'Suchen',
      icon: 'search-outline'
    },
    {
      title: 'Login',
      icon: 'log-in-outline',
      link: '/auth/login'
    }
  ];

  constructor() { }
}
